/**
 * Convert markdown-style AI content to styled HTML for ODDSIS World Cup pages.
 */
export function renderAIContent(text) {
  if (!text) return '';
  return text
    // Headers
    .replace(/####\s*(.*)/g, '<h4 class="text-sm font-semibold text-slate-200 mt-4 mb-1">$1</h4>')
    .replace(/###\s*(.*)/g, '<h3 class="text-base font-bold text-white mt-5 mb-2">$1</h3>')
    .replace(/##\s*(.*)/g, '<h2 class="text-lg font-bold text-amber-400 mt-6 mb-2 border-b border-amber-500/10 pb-1">$1</h2>')
    // Bold
    .replace(/\*\*(.*?)\*\*/g, '<strong class="text-white font-semibold">$1</strong>')
    // ODDSIS highlight
    .replace(/ODDSIS/g, '<span class="text-emerald-400 font-semibold">ODDSIS</span>')
    // Paragraphs
    .replace(/\n\n/g, '</p><p class="mb-3">')
    .replace(/\n/g, '<br/>');
}

export const AI_CONTENT_CLASSES = "prose prose-sm prose-invert max-w-none text-slate-300 leading-relaxed text-sm [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-3 [&_li]:mb-1";
